//TODO: Check if variable exists when referencing to variable
//TODO: Add validation for colors
import RCore from 'RCore';
import React from 'react';
import * as rmd from 'material-ui';
import CheckCircle from 'material-ui/svg-icons/action/check-circle';
import AddPhoto from 'material-ui/svg-icons/image/add-a-photo';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Collapse from 'rc-collapse';
import ImageUploaderContainer from './ImageUploaderContainer';
import cx from 'classnames';
const { Panel } = Collapse;
import { SketchPicker } from 'react-color';

const isHexColor = string => {
    const hexColorRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/g;
    return !!string.match(hexColorRegex);
};

const isRGBAColor = string => {
    const rgbaColorRegex = /rgba\([0-9\s]*\s*,\s*[0-9\s]*,\s*[0-9\s]*,\s*[0-9\.\s)]*/g;
    return !!string.match(rgbaColorRegex);
};

const isRGBColor = string => {
    const rgbColorRegex = /rgb\([0-9\s]*\s*,\s*[0-9\s]*,\s*[0-9\s]*\s*\)]*/g;
    return !!string.match(rgbColorRegex);
};

class SassVariablesEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            userVariables: props.userVariables || {},
            userImages: props.userImages || [],
            currentlyEditingVariable: null,
            compileError: false,
            wrongVariableName: null,
            initialCssGenerated: false,
            publishing: false,
            saved: true
        };

        this.i18dict = SassVariablesEditor.i18;
        this.i18 = RCore.i18.bind(this);
    }

    componentWillUpdate(nextProps, nextState) {
        if (nextState.saved === false) {
            window.addEventListener('beforeunload', this.saveAlert);
            this.props.router.setRouteLeaveHook(this.props.route, this.saveAlert);
        } else if (nextState.saved === true) {
            window.removeEventListener('beforeunload', this.saveAlert);
            this.props.router.setRouteLeaveHook(this.props.route, () => true);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevState.currentlyEditingVariable !== this.state.currentlyEditingVariable &&
            this.props.onEditVariableChange
        ) {
            this.props.onEditVariableChange(this.state.currentlyEditingVariable);
        }
    }

    static contextTypes = {
        info: PropTypes.object
    };

    handleVariableChange = (name, value, asPromise) => {
        let { userVariables } = this.state;
        let _userVariables = { ...userVariables }; //copy

        _userVariables[name] = value;

        if (asPromise) {
            return new Promise(resolve => {
                this.setState(
                    {
                        userVariables: _userVariables
                    },
                    resolve()
                );
            });
        }

        this.setState({
            userVariables: _userVariables
        });
    };

    handleColorPickerRequest = name => this.setState({ colorPickerFor: name });
    handleImagePickerRequest = name => {
        if (name) {
            this.refs[name].focus();
        } else {
            this.refs[name].blur();
        }
        this.props.onImagePickerRequest(name);
        this.setState({ imagePickerFor: name, currentlyEditingVariable: name });
    };

    handleVariableInputBlur = (name, value, changeVariable) => {
        let previousValue = this.state.previousInputValue;
        if (previousValue === value) {
            this.setState({
                currentlyEditingVariable: null
            });
            return;
        }

        if (this.props.onVariablesUpdate)
            this.props.onVariablesUpdate(this.getCurrentVariables(), name).then(css => {
                if (css.error) {
                    this.setState({
                        compileError: true,
                        wrongVariableName: name
                    });
                } else {
                    this.setState(
                        {
                            currentlyEditingVariable: null,
                            compileError: false,
                            saved: false,
                            wrongVariableName: null
                        },
                        () => {
                            this.addCssToPage(css);
                            this.props.onCssUpdated();
                        }
                    );
                }
            });
    };

    saveAlert = e => {
        let confirmationMessage = 'You did not save theme changes. Are you sure you want to leave?';
        (e || window.event).returnValue = confirmationMessage;
        return confirmationMessage;
    };

    generateInitialCss = () => {
        if (this.props.error) return;
        if (this.state.initialCssGenerated || _.isEmpty(this.props.variables)) return;

        let variables = this.getCurrentVariables();

        if (this.props.onVariablesUpdate)
            this.props.onVariablesUpdate(variables).then(css => {
                this.setState({ initialCssGenerated: true }, this.addCssToPage(css));
            });
    };

    addCssToPage = css => {
        if (!document.querySelector('#wdp-user-style')) {
            let style = document.createElement('style');
            style.id = 'wdp-user-style';
            style.innerHTML = css;
            document.querySelector('head').appendChild(style);
        } else {
            document.querySelector('#wdp-user-style').innerHTML = css;
        }
    };

    getCurrentVariables = onlyDefault => {
        let { userVariables } = this.state;
        let { variables } = this.props;
        let { widgets, theme } = variables;

        let flattenVariables = _.flatten([...theme, ...widgets].map(w => w.variables));

        return flattenVariables.reduce((total, cur) => {
            let variableValue = userVariables[cur.name] || cur.value;
            if (onlyDefault) {
                variableValue = cur.value;
            }
            total[cur.name] = variableValue;
            return total;
        }, {});
    };

    findValue = (name, findInDefault) => {
        if (!name) return;
        let val = this.getCurrentVariables(findInDefault)[name];
        if (val && val[0] === '$') return this.findValue(val.substring(1));
        return val;
    };

    handleVariableInputFocus = (name, value) => {
        this.setState({
            currentlyEditingVariable: name,
            previousInputValue: value
        });
    };

    onImagePick = (variable, value) => {
        this.setState({
            imagePickerFor: null
        });
        this.props.onImagePickerRequest(null);
        this.handleVariableChange(variable, value, 'asPromise').then(() => {
            this.handleVariableInputBlur(variable, value);
        });
    };

    rgbaToString = ({ r, g, b, a }) => `rgba(${r}, ${g}, ${b}, ${a})`;

    renderVariable = (variable, widget, colorPickerColors) => {
        let userVariableValue = this.state.userVariables[variable.name];
        let { currentlyEditingVariable, compileError, wrongVariableName } = this.state;
        let { themeId } = this.props;
        let { name, comment, value } = variable;
        if (userVariableValue !== undefined) {
            value = userVariableValue;
        }
        let inputValue = this.state[name] === undefined ? value : this.state[name];
        let realValue = inputValue;

        let isDisabled = false;
        let isError = false;
        let variableWasChanged = false;
        if (currentlyEditingVariable) {
            variableWasChanged = this.state.previousInputValue !== this.state.userVariables[currentlyEditingVariable];
            isDisabled = variableWasChanged && name !== currentlyEditingVariable;
        }

        if (realValue[0] === '$') realValue = this.findValue(realValue.substring(1));

        let labelText = name;

        if (wrongVariableName === name) {
            isError = true;
        } else if (compileError) {
            isDisabled = true;
        }

        let isColor = name.indexOf('color') !== -1 || name.indexOf('gray') !== -1;
        let isImage = _.last(name.split('-')) === 'image';

        return (
            <div className="rlz-theme-customizer__variable" key={name}>
                <small style={{ marginTop: '25px', display: 'block' }}>{comment}</small>

                <rmd.TextField
                    floatingLabelText={'$' + labelText}
                    floatingLabelStyle={{ fontFamily: 'monospace' }}
                    value={inputValue}
                    fullWidth
                    ref={name}
                    disabled={isDisabled}
                    style={{ marginTop: '-14px' }}
                    errorText={isError && 'Wrong variable value'}
                    onChange={e => this.handleVariableChange(name, e.target.value)}
                    onBlur={e => this.handleVariableInputBlur(name, e.target.value, widget.name)}
                    onFocus={e => this.handleVariableInputFocus(name, e.target.value)}
                />

                <div className={`wdp wdp_${themeId}`}>
                    {isColor && (
                        <div
                            key="color-main"
                            onClick={this.handleColorPickerRequest.bind(this, name)}
                            className={cx(
                                'rlz-theme-customizer__variable-extended-input rlz-theme-customizer__color-preview',
                                { [`bg-${name}`]: true }
                            )}
                            style={{ background: realValue }}
                        />
                    )}
                    {isImage &&
                        !this.state.imagePickerFor && (
                            <div
                                key="image-main"
                                onClick={this.handleImagePickerRequest.bind(this, name)}
                                className="rlz-theme-customizer__variable-extended-input rlz-theme-customizer__image-request-button"
                            >
                                <AddPhoto />
                            </div>
                        )}
                    {this.state.colorPickerFor === name && (
                        <div className={`rlz-theme-customizer__color-picker-tool`}>
                            <div
                                style={{
                                    position: 'fixed',
                                    top: '0px',
                                    right: '0px',
                                    bottom: '0px',
                                    left: '0px'
                                }}
                                onClick={() => this.handleColorPickerRequest(null)}
                            />
                            <SketchPicker
                                color={realValue}
                                presetColors={colorPickerColors}
                                onChange={(color, e) => this.handleVariableChange(name, this.rgbaToString(color.rgb))}
                                onChangeComplete={(color, e) => {
                                    this.handleVariableInputBlur(name, this.rgbaToString(color.rgb), widget.name);
                                }}
                            />
                        </div>
                    )}
                    {currentlyEditingVariable === name &&
                        variableWasChanged && (
                            <span className="rlz-theme-customizer__apply-variable-change">
                                <CheckCircle />
                            </span>
                        )}
                    {isColor && (
                        <div key="color-transparent" className="rlz-theme-customizer__color-preview_transparent" />
                    )}
                </div>
            </div>
        );
    };

    renderVariables = () => {
        let { widgets: widgetsVariables = [], theme: themeVariables = [] } = this.props.variables;

        let { widgetsToShow, sectionsToShow } = this.props;
        // ADD COLOR PICKER
        let colorPickerColors = [];
        themeVariables.find(t => t.id === 'Color palette').variables.forEach((v, i) => {
            let value = v.value;
            if (this.state.userVariables[v.name]) value = this.state.userVariables[v.name];
            if (isHexColor(value) || isRGBAColor(value) || isRGBColor(value))
                colorPickerColors.push({ key: v.name, color: value, title: `${v.name}, ${value}` });
        });

        return (
            <div className="rlz-theme-customizer__variables">
                <div className="rlz-theme-customizer__theme-variables">
                    <Collapse onChange={this.props.onThemeCollapseChange} defaultActiveKey={sectionsToShow}>
                        {themeVariables.map((t, i) => {
                            return (
                                <Panel showArrow header={t.name} key={t.name}>
                                    <div key={i} className="rlz-theme-customizer__theme-variables">
                                        {t.variables.map(v => this.renderVariable(v, t, colorPickerColors))}
                                    </div>
                                </Panel>
                            );
                        })}
                    </Collapse>
                </div>
                <div className="rlz-theme-customizer__widgets-variables">
                    <h3 style={{ marginLeft: '15px' }}>Widgets variables</h3>
                    <Collapse onChange={this.props.onWidgetsCollapseChange} defaultActiveKey={widgetsToShow}>
                        {widgetsVariables.map((w, i) => {
                            if (!w.variables.length) return;
                            return (
                                <Panel showArrow header={w.name} key={w.id}>
                                    <div key={i} className="rlz-theme-customizer__theme-variables">
                                        {w.variables.map(v => this.renderVariable(v, w, colorPickerColors))}
                                    </div>
                                    {w.variables.length === 0 && (
                                        <div className="rlz-theme-customizer__no-variables">
                                            widget does not variables to edit
                                        </div>
                                    )}
                                </Panel>
                            );
                        })}
                    </Collapse>
                </div>
            </div>
        );
    };

    renderSaveControl = () => {
        let { currentlyEditingVariable, saved, compileError, publishing, wrongVariableName } = this.state;
        let publishIsDisabled = false;
        let publishLabel = 'Save & Publish';

        let variableWasChanged = this.state.previousInputValue !== this.state.userVariables[currentlyEditingVariable];

        if (saved) {
            publishLabel = 'Saved';
            publishIsDisabled = true;
        }

        if (currentlyEditingVariable && variableWasChanged) {
            publishLabel = 'Editing in progress';
            publishIsDisabled = true;
        }
        if (compileError) {
            publishLabel = `Wrong variable value (${wrongVariableName})`;
            publishIsDisabled = true;
        }

        if (publishing) {
            publishLabel = 'CSS is publishing';
            publishIsDisabled = true;
        }

        return (
            <div className="rlz-theme-customizer__save-control">
                {/*<rmd.RaisedButton className="rlz-theme-customizer__reset" onClick={this.props.onReset} label="Reset"/>*/}
                <rmd.FlatButton
                    className="rlz-theme-customizer__publish"
                    onClick={() => {
                        this.setState({
                            publishing: true
                        });
                        this.props.onPublish(this.getCurrentVariables()).then(res => this.setState(res));
                    }}
                    label={publishLabel}
                    primary
                    disabled={publishIsDisabled}
                />
                {/*
                <rmd.RaisedButton
                    className="rlz-theme-customizer__save"
                    onClick={() => this.props.onSave(this.getCurrentVariables())}
                    label="Save"
                    primary={true}
                />
*/}
            </div>
        );
    };

    render() {
        let { variables } = this.props;

        if (_.isEmpty(variables)) return null;
        this.generateInitialCss();

        let wrapperClasses = cx('rlz-theme-cutsomizer', {
            'rlz-theme-customizer_drawer-is-open': this.state.imagePickerFor
        });

        return (
            <div className={wrapperClasses}>
                <div className="rlz-theme-customizer__control">
                    <div className="rlz-theme-customizer__inner-wrapper">
                        {this.renderSaveControl()}
                        {this.renderVariables()}
                        {this.renderSaveControl()}
                    </div>
                </div>
                {this.state.imagePickerFor && (
                    <ImageUploaderContainer
                        onCopy={copiedValue => this.onImagePick(this.state.imagePickerFor, copiedValue)}
                        onClose={() => {
                            this.setState(
                                {
                                    imagePickerFor: null
                                },
                                this.props.onImagePickerRequest(null)
                            );
                        }}
                        modal
                        galleryFirst
                        cdnOnly
                        cdnLabel="Pick"
                    />
                )}
            </div>
        );
    }
}

const i18 = (SassVariablesEditor.i18 = {
    da: {},
    en: {
        'wrong.variable.value': 'wrong variable value'
    }
});

export default SassVariablesEditor;
export { SassVariablesEditor, i18 };



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/SassVariablesEditor.js
 **/